import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { fetchCmsMetaData } from "../../../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../../../Components/Utility/setMetaTags";

function HostSetting() {
  const navigate = useNavigate();
const [meta,setMeta] = useState();
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    gender: "",
    city_id: "",
    occupation: "",
    language: "",
    about_me: "",
    title: "",
    total_year_of_experience: "",
  });

  const [cities, setCities] = useState([]);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/host/getuserProfile`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          },
        );

        if (res.data && res.data.data) {
          const user = res.data.data;
          setFormData((prev) => ({
            ...prev,
            name: `${user.first_name || ""} ${user.last_name || ""}`.trim(),
            dob: user.dob ? String(user.dob).split(" ")[0] : "",
            gender: user.gender || "",
            country_id: user.country_id || "",
            city_id: user.city || "",
            occupation: user.occupation || "",
            language: user.language || "",
            about_me: user.about_me || "",
            title: user.host_title || "",
            total_year_of_experience: user.total_year_of_experience || "",
            profile_image_url: user.profile_image
              ? `${res.data.base_url}${user.profile_image}`
              : null,
          }));

          if (user.country_id) fetchCities(user.country_id);
        }
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    };

    const fetchCities = async (countryId) => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/get-city-by-country/${countryId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          },
        );
        if (res.data?.status) setCities(res.data.data || []);
      } catch (err) {
        console.error("Error fetching cities:", err);
        setCities([]);
      }
    };

    fetchProfile();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // sanitize numeric-only for experience
    if (name === "total_year_of_experience") {
      const onlyDigits = value.replace(/[^\d.]/g, "");
      setFormData((prev) => ({ ...prev, [name]: onlyDigits }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    // Age >= 18 validation
    if (formData.dob) {
      const today = new Date();
      const birthDate = new Date(formData.dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
      if (age < 18) {
        toast.error(
          "You must be at least 18 years old to update your profile.",
        );
        return;
      }
    }

    try {
      const res = await toast.promise(
        axios.post(
          `${process.env.REACT_APP_API_BASE}/host/update-profile`,
          {
            name: formData.name,
            dob: formData.dob,
            gender: formData.gender,
            city: formData.city_id ? Number(formData.city_id) : undefined,
            occupation: formData.occupation,
            language: formData.language,
            about_me: formData.about_me,
            title: formData.title,
            total_year_of_experience: formData.total_year_of_experience,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              "Content-Type": "application/json",
            },
          },
        ),
        {
          loading: "Profile Updating...",
          success: "Profile Updated successfully",
          error: "Failed to update profile ❌",
        },
      );

      if (res.data?.status) {
        if (res.data.data) {
          localStorage.setItem("user", JSON.stringify(res.data.data));
        }
        navigate("/account-setting", { state: { updated: true } });
      }
    } catch (err) {
      console.error("Error updating profile:", err);
    }
  };

  // ✅ Upload image function (direct onChange se call hoga)
  const handleUploadImage = async (file) => {
    if (!file) return;

    // ✅ File size check (2MB = 2048 KB)
    const maxSize = 2 * 1024 * 1024; // 2 MB in bytes
    if (file.size > maxSize) {
      toast.error("The profile image must not be greater than 2048 KB (2 MB).");
      file.target.value = "";
      return; // ❌ Stop upload if too large
    }

    const fd = new FormData();
    fd.append("profile_image", file);

    try {
      setUploading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/host/updateProfileImage`,
        fd,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (res.data.status) {
        toast.success("Profile image updated successfully!");
        if (res.data.image_url) {
          setFormData((prev) => ({
            ...prev,
            profile_image_url: res.data.image_url,
            profile_image: null,
          }));
        }

        const userWithBaseUrl = {
          ...res.data.data.user,
          base_url: res.data.base_url,
        };

        localStorage.setItem("user", JSON.stringify(userWithBaseUrl));
        window.location.reload();
      } else {
        toast.error(res.data.message || "Failed to upload image.");
      }
    } catch (err) {
      console.error("Error uploading image:", err);
      toast.error("Failed to upload image!");
    } finally {
      setUploading(false); // stop loader
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("account");
      setMeta(data);
    };

    loadMeta();
  }, []);

  return (
    <>
      <section className="mng_bottomss user_allls profiles all_titless myprofiless">
        <SetMetaTags
        title= {meta?.meta_title || "Account | Weyfarin"}
        description={meta?.meta_description || "Account | Weyfarin"}
      
      />
        <div className="prfo_listst lastsst al_sec_ctxt ac_settingss">
          <div className="row">
            <div className="col-lg-8">
              <div className="discriptionns">
                <h3>Personal Information</h3>
              </div>

              <div className="form_al_fildss">
                <form onSubmit={handleSave}>
                  <div className="row">
                    <div className="col-lg-3">
                      <div className="usr_profl text-center edtiss">
                        <div className="usr_mgss">
                          {formData.profile_image ? (
                            <img
                              src={URL.createObjectURL(formData.profile_image)}
                              alt="Profile Preview"
                            />
                          ) : formData.profile_image_url ? (
                            <img
                              src={formData.profile_image_url}
                              alt="Profile"
                            />
                          ) : (
                            <img src="images/user_dh.png" alt="default" />
                          )}
                        </div>
                        <div className="edit_pencilss">
                          <input
                            type="file"
                            name="profile_image"
                            accept="image/*"
                            id="profileUpload"
                            style={{ display: "none" }}
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const maxSize = 2 * 1024 * 1024; // 2 MB
                                const allowedTypes = [
                                  "image/jpeg",
                                  "image/jpg",
                                  "image/png",
                                ];

                                // ❌ Invalid file type
                                if (!allowedTypes.includes(file.type)) {
                                  toast.error(
                                    "The profile image must be a file of type: jpg, jpeg, png.",
                                  );
                                  e.target.value = ""; // clear field
                                  setFormData((prev) => ({
                                    ...prev,
                                    profile_image: null,
                                  })); // ✅ clear preview
                                  return;
                                }

                                if (file.size > maxSize) {
                                  toast.error(
                                    "The profile image must not be greater than 2048 KB (2 MB).",
                                  );
                                  e.target.value = ""; // ✅ Reset input if too large
                                  return;
                                }
                                setFormData((prev) => ({
                                  ...prev,
                                  profile_image: file,
                                }));
                                // ✅ Select karte hi upload
                                handleUploadImage(file);
                              }
                            }}
                          />
                          <label
                            htmlFor="profileUpload"
                            style={{
                              // cursor: "pointer",
                              cursor: uploading ? "not-allowed" : "pointer",
                            }}
                          >
                            <img src="/images/Pencils.png" alt="" />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <label>Name</label>
                        <input
                          className="form-control"
                          type="text"
                          name="name"
                          value={formData.name}
                          onKeyPress={(e) => {
                            const regex = /^[A-Za-z ]+$/;
                            if (!regex.test(e.key)) e.preventDefault();
                          }}
                          maxLength={50}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <label>Gender</label>
                        <select
                          className="form-control"
                          name="gender"
                          value={formData.gender}
                          onChange={handleChange}
                        >
                          <option value="">Select</option>
                          <option value="1">Male</option>
                          <option value="2">Female</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <label>City</label>
                        <select
                          className="form-control"
                          name="city_id"
                          value={formData.city_id}
                          onChange={handleChange}
                        >
                          <option value="">Select</option>
                          {cities.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <label>Occupation</label>
                        <input
                          className="form-control"
                          type="text"
                          name="occupation"
                          value={formData.occupation}
                          onChange={handleChange}
                          maxLength={50}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <label>Date of Birth</label>
                        <input
                          className="form-control"
                          type="date"
                          name="dob"
                          value={formData.dob}
                          max={new Date().toISOString().split("T")[0]}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6 col-sm-6">
                      <div className="form-group">
                        <label>Languages</label>
                        <input
                          className="form-control"
                          type="text"
                          name="language"
                          value={formData.language}
                          onKeyPress={(e) => {
                            const regex = /^[A-Za-z ,]+$/; // allow commas
                            if (!regex.test(e.key)) e.preventDefault();
                          }}
                          maxLength={80}
                          onChange={handleChange}
                          placeholder="e.g., English, Hindi"
                        />
                      </div>
                    </div>

                    <div className="col-lg-12 mt-3">
                      <div className="discriptionns">
                        <h3>Other Information</h3>

                        <div className="form-group managess">
                          <label className="d-flex align-item-center">
                            Intro{" "}
                            <span
                              style={{ marginLeft: "6px", cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                              data-tooltip-id="intro-tooltip"
                              data-tooltip-content="Max 1000 letters allowed to enter"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ width: "16px", height: "16px", color: "#666666" }}
                              >
                                <circle cx="12" cy="12" r="10" />
                                <line x1="12" y1="16" x2="12" y2="12" />
                                <line x1="12" y1="8" x2="12" y2="8" />
                              </svg>
                            </span>
                          </label>
                          <textarea
                            className="form-control"
                            name="about_me"
                            rows="4"
                            value={formData.about_me}
                            maxLength={1000}
                            onChange={handleChange}
                          ></textarea>
                        </div>

                        <div className="form-group managess">
                          <label className="d-flex align-item-center">
                            Expertise{" "}
                            <span
                              style={{ marginLeft: "6px", cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                              data-tooltip-id="expertise-tooltip"
                              data-tooltip-content="Max 1000 letters allowed to enter"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ width: "16px", height: "16px", color: "#666666" }}
                              >
                                <circle cx="12" cy="12" r="10" />
                                <line x1="12" y1="16" x2="12" y2="12" />
                                <line x1="12" y1="8" x2="12" y2="8" />
                              </svg>
                            </span>
                          </label>
                          <textarea
                            className="form-control"
                            name="title"
                            rows="4"
                            value={formData.title}
                            onChange={handleChange}
                            maxLength={1000}
                            placeholder="e.g., Laravel Expert"
                          ></textarea>
                        </div>

                        <div className="form-group managess">
                          <label>Experience</label>
                          <input
                            className="form-control"
                            type="text"
                            name="total_year_of_experience"
                            placeholder="Years (e.g., 6)"
                            value={formData.total_year_of_experience}
                            onChange={handleChange}
                            maxLength={2}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="submmit">
                        <button type="submit" value="submit">
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Tooltip id="intro-tooltip" />
      <Tooltip id="expertise-tooltip" />
    </>
  );
}

export default HostSetting;
